import { IconButton } from '@zep-us/zus';
import { cn } from '@zep-us/zus';
import { ArrowUpIcon, SquareSmallFillIcon } from '@zep-us/zus/icons';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { FileMaterialAddButton } from '@/views/build/features/ai-prompt-input/components/PromptTextArea/MaterialAddButton';
import { useAiBuilderChatCopy } from '../hooks/useAiBuilderChatCopy';
import { AiBuilderFileChip } from './AiBuilderFileChip';
type AiBuilderComposerControlBarProps = {
  attachedFile: {
    fileName: string;
    extension?: string;
  } | null;
  canSubmit: boolean;
  canUseSourceAttachment: boolean;
  isGenerating: boolean;
  onOpenFilePicker: () => void;
  onRemoveAttachedFile: () => void;
  remainingTurnsLabel: string | null;
};
export const AiBuilderComposerControlBar = ({
  attachedFile,
  canSubmit,
  canUseSourceAttachment,
  isGenerating,
  onOpenFilePicker,
  onRemoveAttachedFile,
  remainingTurnsLabel
}: AiBuilderComposerControlBarProps) => {
  const copy = useAiBuilderChatCopy();
  return <div className="flex w-full items-center justify-between gap-xs" data-sentry-component="AiBuilderComposerControlBar" data-sentry-source-file="AiBuilderComposerControlBar.tsx">
      {/* 시안(37421:22804) — 파일이 첨부된 경우 문서 파일 버튼 대신 파일 칩을 노출한다 */}
      <div className="flex min-w-0 items-center gap-2xs">
        {attachedFile ? <AiBuilderFileChip fileName={attachedFile.fileName} extension={attachedFile.extension} onRemove={onRemoveAttachedFile} disabled={!canUseSourceAttachment} /> : <FileMaterialAddButton rounded="default" size="sm" disabled={!canUseSourceAttachment} onClick={onOpenFilePicker} />}
      </div>

      <div className="flex items-center gap-md">
        {remainingTurnsLabel && <span className="shrink-0 whitespace-nowrap text-body-sm-semibold text-neutral">
            {remainingTurnsLabel}
          </span>}
        <IconButton type="submit" variant="contained" intent="strong" size="sm" rounded="full" className={cn(!isGenerating && !canSubmit && '!bg-gray-300')} aria-label={isGenerating ? copy.composer.cancelGenerationAriaLabel : copy.composer.sendAriaLabel} disabled={!isGenerating && !canSubmit} data-sentry-element="IconButton" data-sentry-source-file="AiBuilderComposerControlBar.tsx">
          {isGenerating ? <SquareSmallFillIcon size="md" fill={ICON_COLOR.inverse} /> : <ArrowUpIcon size="md" fill={ICON_COLOR.inverse} />}
        </IconButton>
      </div>
    </div>;
};